import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateInfo } from '@/api/user';

import { useAppDispatch } from '@/hooks/redux';

import { notifyUserChanged } from '@/redux/auth/actions';

import { FinancialInfo } from '@/types/finance';

import { addFinancialInfo } from '../api/finances';

type SubmitLiabilitiesPayload = {
  hasLiability: boolean;
  liabilities: FinancialInfo[];
};

type UseSubmitLiabilitiesParams = { onSuccess?: () => void };

export function useSubmitLiabilities({
  onSuccess,
}: UseSubmitLiabilitiesParams) {
  const queryClient = useQueryClient();
  const dispatch = useAppDispatch();

  return useMutation({
    mutationFn: async ({
      hasLiability,
      liabilities,
    }: SubmitLiabilitiesPayload) => {
      const calls: Promise<unknown>[] = [updateInfo({ hasLiability })];

      if (hasLiability) {
        calls.push(addFinancialInfo(liabilities));
      }

      await Promise.all(calls);
    },
    onSuccess: () => {
      dispatch(notifyUserChanged());
      queryClient.invalidateQueries({ queryKey: ['financial-info'] });

      onSuccess?.();
    },
  });
}
